import { inject, Injectable } from '@angular/core';

import { UserContextService } from 'rev-shared/security/UserContext.Service';
import { dualStreamCutoffDate } from 'rev-shared/video/Constants';

import { SearchService } from './Search.Service';
import { SearchQueryBuilder } from './SearchQueryBuilder';
import { SortWhenUploaded } from './SearchConstants';
import { ISearchLoader, ISearchResult } from './Contract';

const TypeaheadResultSize = 25;

@Injectable({
	providedIn: 'root'
})
export class VideoSearchService {
	private readonly SearchService: SearchService = inject(SearchService);
	private readonly UserContext: UserContextService = inject(UserContextService);

	public getVideoSearchLoader(accountId: string, loaderOpts?: any): ISearchLoader {
		return this.SearchService.searchFnToLoader(accountId, (query: string, searchOpts: any, scrollId: string) => {
			const opts = { ...loaderOpts, ...searchOpts };
			const filterBuilder = new SearchQueryBuilder()
				.values('Title.text', query?.toLocaleLowerCase().split(' '))
				.value('HasHls', 'true')
				.value('Is360', 'false')
				.value('HasAudioOnly', 'false')
				.value('LegalHold', 'false')
				.value('Approval.status', 'Approved')
				.boolean('HasDualStreams', opts.hasDual)
				.parsedQuery(!opts.isAllVideos ? `OwnerUserId:(${this.UserContext.getUser().id})` : '');

			const queryBuilder = new SearchQueryBuilder();
			if(opts.hasDual) {
				//WhenUploaded field is not working correctly when passed in the filter. Using query instead.
				queryBuilder.dateRange('WhenUploaded', dualStreamCutoffDate, null);
			}

			return this.SearchService.getVideos({
				useEditAcl: true,
				parsedQuery: queryBuilder.buildQuery(),
				parsedFilter: filterBuilder.buildQuery(),
				sortField: SortWhenUploaded,
				accountId: this.UserContext.getAccount().id,
				count: TypeaheadResultSize,
				scrollId,
				thumbnailSheets: true
			})
				.then(searchResults => {
					return {
						scrollId: searchResults.scrollId,
						items: searchResults.videos.map(v => {
							return {
								...v,
								durationMs: v.duration
							};
						}),
						count: searchResults.totalHits
					} as ISearchResult;
				});
		});
	}

}
